// lib/msalConfig.ts
import { Configuration, PopupRequest, PublicClientApplication } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.NEXT_PUBLIC_B2C_CLIENT_ID!,
    authority: `https://${process.env.NEXT_PUBLIC_B2C_TENANT_NAME}.b2clogin.com/${process.env.NEXT_PUBLIC_B2C_TENANT_NAME}.onmicrosoft.com/${process.env.NEXT_PUBLIC_B2C_SIGNUP_POLICY}`,
    knownAuthorities: [`${process.env.NEXT_PUBLIC_B2C_TENANT_NAME}.b2clogin.com`],
    redirectUri: process.env.NEXT_PUBLIC_REDIRECT_URI || 'http://localhost:3000',
    postLogoutRedirectUri: '/',
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

// Types pour les policies B2C
interface B2CPolicies {
  names: {
    signUp: string;
    signUpSignIn: string;
    editProfile?: string;
    passwordReset?: string;
  };
  authorities: {
    signUp: {
      authority: string;
    };
    signUpSignIn: {
      authority: string;
    };
  };
}

export const b2cPolicies: B2CPolicies = {
  names: {
    signUp: process.env.NEXT_PUBLIC_B2C_SIGNUP_POLICY!,
    signUpSignIn: process.env.NEXT_PUBLIC_B2C_SIGNUP_POLICY!,
    editProfile: process.env.NEXT_PUBLIC_B2C_EDIT_PROFILE_POLICY,
    passwordReset: process.env.NEXT_PUBLIC_B2C_PASSWORD_RESET_POLICY,
  },
  authorities: {
    signUp: {
      authority: `https://${process.env.NEXT_PUBLIC_B2C_TENANT_NAME}.b2clogin.com/${process.env.NEXT_PUBLIC_B2C_TENANT_NAME}.onmicrosoft.com/${process.env.NEXT_PUBLIC_B2C_SIGNUP_POLICY}`,
    },
    signUpSignIn: {
      authority: `https://${process.env.NEXT_PUBLIC_B2C_TENANT_NAME}.b2clogin.com/${process.env.NEXT_PUBLIC_B2C_TENANT_NAME}.onmicrosoft.com/${process.env.NEXT_PUBLIC_B2C_SIGNUP_POLICY}`,
    },
  },
};

// Types pour les requêtes
export const signupRequest: PopupRequest = {
  scopes: ['openid', 'profile', 'offline_access'],
  prompt: 'create',
};

// Instance MSAL singleton
export const msalInstance = new PublicClientApplication(msalConfig);

